/**
 * @desc 物料选择
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialTypeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialTypeDTO>>> {
  return defHttp.post({
    url: '/web/materialManage/listMaterialType',
    data,
  });
}

export function mock(
  data: defs.MaterialTypeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialTypeDTO>>> {
  return defHttp.post({
    url: '/mock/web/materialManage/listMaterialType',
    data,
  });
}
